var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnBtnEdit = function SvgIcnBtnEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    className: "cursor-pointer",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H20V20H2C0.895431 20 0 19.1046 0 18V2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57755 13.8079L5.58259 12.242L9.94558 7.90696L11.5263 9.45815L7.14344 13.8129L5.57755 13.8079ZM12.424 8.56617L13.3172 7.67879C13.4411 7.55564 13.4417 7.35533 13.3186 7.23139L12.2037 6.1093C12.0805 5.98535 11.8802 5.98471 11.7563 6.10786L10.8433 7.01497L12.424 8.56617ZM7.81846 14.9261C7.71926 15.0246 7.58497 15.0798 7.44513 15.0793L4.83531 15.0709C4.54411 15.07 4.3088 14.8332 4.30974 14.542L4.31814 11.9321C4.31859 11.7923 4.37457 11.6584 4.47377 11.5598L10.8644 5.21018C11.4841 4.59444 12.4856 4.59767 13.1014 5.21738L14.2163 6.33947C14.832 6.95919 14.8288 7.96072 14.2091 8.57646L7.81846 14.9261Z",
    fill: "#57595E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.8L15.0266 14.8001",
    stroke: "#57595E",
    strokeWidth: 1.12473,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnBtnEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_btn_edit.6cf8b31f.svg";
export { ForwardRef as ReactComponent };